import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import {getAssignmentDataView} from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import FromFieldDate from "../../atoms/FromFieldDate";
import FromFieldDateHari from "../../atoms/FromFieldDateHari";
import FromSpFieldTextAreaHari from "../../atoms/FromSpFieldTextAreaHari";

import FromFieldTime from "../../atoms/FromFieldTime";

function IRAssessmentViewReport() {
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [aInfo, setAInfo] = useState([]);
    const [mInfo, setMInfo] = useState([]);

    const [assignedDate, setAssignedDate] = useState('');

    const [acceptedDate, setAcceptedDate] = useState('');

    const [assignmentNumber, setAssignmentNumber] = useState('');
    const [ErrAssignmentNumber, setErrAssignmentNumber] = useState('');

    const [detailProblem, setDetailProblem] = useState('');

    const [detailProblemIdentified, setDetailProblemIdentified] = useState('');

    const [materialUsed, setMaterialUsed] = useState('');

    const [formCategory, setFormCategory] = useState('');

    const [assignedTo, setAssignedTo] = useState('');

    const [dateOfCopletion, setDateOfCopletion] = useState('');

    const [timeOfCompletion, setTimeOfCompletion] = useState('');

    const [nextServiceDue, setNextServiceDue] = useState('');

    const [nextServiceDate, setNextServiceDate] = useState('');

    const [closingNote, setClosingNote] = useState('');

    const [repairCategory, setRepairCategory] = useState('');

    const [materials, setMaterials] = useState([{
        date: '',
        name: '',
        partNumber: '',
        make: '',
        model: '',
        serialNo: '',
        qty: '',
        cost: ''
    }]);

    const [showTextField, setShowTextField] = useState(false);

    const resetUserInfo = () => {
        setAssignmentNumber('');
    };

    const handleFormCategory = (e) => {
        setFormCategory(e.target.value);
    }

    const handleClosingNote = (e) => {
        setClosingNote(e.target.value);
    }

    // Inside your function that processes the data
    const getTagInfo = function (decryptedAssignmentNo) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'assignment_no': decryptedAssignmentNo},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        let oData = {'token': EncryptData};

        getAssignmentDataView(oData).then(function (res) {
            // If there is data in the response
            if (res.data.data.assessment_data) {
                setErrMsg('');  // Clear any error messages
                setAInfo(res.data.data.list_equipment);  // Set the full array of equipment info
                setMInfo(res.data.data.list_material_used);  // Set the full array of material data info
                const firstItem = res.data.data.assessment_data;
                setAssignmentNumber(firstItem.assignment_no);
                setAssignedTo(firstItem.endUser_name);
                setAssignedDate(new Date(firstItem.assignedDate));
                setAcceptedDate(new Date(firstItem.assignment_accepted_date));
                setFormCategory(firstItem.cat_ir);
                setRepairCategory(firstItem.under_warrenty);
                setDetailProblem(firstItem.problem_desc);
                setDetailProblemIdentified(firstItem.detail_problem_identified);
                setMaterialUsed(firstItem.materialUsed);
                setDateOfCopletion(new Date(firstItem.dateOfCopletion));

                // Handle timeOfCompletion by appending it to the dateOfCompletion
                if (firstItem.dateOfCopletion && firstItem.timeOfCompletion) {
                    const dateOfCompletion = new Date(firstItem.dateOfCopletion);
                    const [hours, minutes, seconds] = firstItem.timeOfCompletion.split(':');
                    dateOfCompletion.setHours(hours, minutes, seconds);
                    setTimeOfCompletion(dateOfCompletion);
                } else {
                    setTimeOfCompletion(null);  // Handle null cases
                }

                setNextServiceDue(firstItem.nextServiceDue);
                setNextServiceDate(new Date(firstItem.nextServiceDate));
                setClosingNote(firstItem.handleClosingNote);

            } else {
                setErrMsg('Assignment no not found');
                setAInfo([]);  // Reset aInfo to an empty array if no data is found
            }
        }).catch(() => {
            setErrMsg('Failed to fetch data');
            setAInfo([]);  // Handle errors by clearing aInfo
        });
    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Assignment_No = query.get('assignment_no');
    useEffect(() => {
        if(Assignment_No!=='' && Assignment_No!==null){
            
            const decryptedBytes = CryptoJS.AES.decrypt(Assignment_No.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedAssignmentNo = decrypt_data.assignment_no;
            setAssignmentNumber(decryptedAssignmentNo);
            getTagInfo(decryptedAssignmentNo);
        }
    }, []);
    useEffect(() => {
        if (mInfo.length > 0) {
            //alert(mInfo.length); // This will now reflect the updated value
            const mappedMaterials = mInfo.map(material => ({
                date: material.material_date,
                name: material.material_name,
                partNumber: material.material_partNumber,
                make: material.material_make,
                model: material.material_model,
                serialNo: material.material_serialNo,
                qty: material.material_qty,
                cost: material.material_cost,
            }));

            setMaterials(mappedMaterials);
        }
    }, [mInfo]); // Runs whenever `mInfo` changes



    const handleMaterial = (e) => {
        setMaterialUsed(e.target.value);
    }
    const handleServices = (event) => {
        const value = event.target.value;
        setNextServiceDue(event.target.value);
        setShowTextField(value === "Yes");
    }

    const handleInputChange = (index, event) => {
        const {name, value} = event.target;
        const updatedMaterials = materials.map((material, i) => (
            i === index ? {...material, [name]: value} : material
        ));
        setMaterials(updatedMaterials);
    };

    // Encrypt the assignment number
    let encryptedAssignmentNO = CryptoJS.AES.encrypt(
        JSON.stringify({ 'assignment_no': assignmentNumber }),
        process.env.REACT_APP_ENCRYPT_SECRET_KEY
    ).toString();

    const navigate = useNavigate(); //useNavigate inside component

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <h5>View IR Assessment Report</h5>
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert">
                        <i className="bi bi-check-circle-fill"></i>{success}
                    </div>
                ) : (
                    errMsg && (
                        <div className="alert alert-danger" role="alert">
                            <i className="bi bi-exclamation-triangle-fill"></i>{errMsg}
                        </div>
                    )
                )}
            </div>

            <div className="row">
                <div className="col-12 text-right">
                    <button onClick={handleBackClick} className="btn btn-secondary btn-sm ms-3">
                        Back
                    </button>
                    <a href={`/ir-assessment-report?assignment_no=${encodeURIComponent(encryptedAssignmentNO)}`}>
                        <button type="button" className="btn btn-danger btn-sm ms-3">
                            Edit Report
                        </button>
                    </a>
                </div>
            </div>

            <div className='row '>
                <div className='col-12'>&nbsp;</div>
                {/*
                    <div className='row'>
                        <div className='col'><h5 className='align-right'>TAG/Assignment No </h5></div>
                        <div className='col'><input onChange={function (event) {
                            setAssignmentNumber(event.target.value)
                        }} inputValue='' type="text" className="form-control"
                                                    placeholder='Enter the asset TAG'/><p
                            className='invalid-feedback'>{ErrAssignmentNumber}</p></div>
                        <div className='col'>
                            <button onClick={getTagInfo} className='btn btn-info btn-sm'><i
                                className="bi bi-search"></i> Search
                            </button>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href={'/ir-assessment-report'}>
                            <button className='btn btn-info btn-sm'>Reset</button>
                        </a>&nbsp;</div>
                    </div>
                */}
            </div>
            <div className='row'></div>

            <div className="row">

                <div className="row mt-2">

                    <div className="col-6">
                        <div className="row">
                            <div className="col-md-6">
                                <label> FORM Category </label>
                                <span className="star error">  </span>
                            </div>
                            <div className="col-md-6">
                                <select disabled onChange={handleFormCategory} name="formCategory"
                                        className="form-select form-select-sm">
                                    <option value="">Select Form Category</option>
                                    <option value="IRAI"
                                            selected={formCategory === "IRAI" ? "selected" : ''}>IT Assets
                                    </option>
                                    <option value="IRAO"
                                            selected={formCategory === "IRAO" ? "selected" : ''}>Other Asset
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">

                    <div className='col-md-6'>
                        <FromFieldDate
                            disabled={true}
                            label="Assigned Date" star="*" placeholder="YYYY-MM-DD"
                            inputValue={assignedDate}
                            setInputValue={setAssignedDate}
                        />
                    </div>
                    <div className="col-6">
                        <FromFieldText
                            readOnly={true}
                            star="*"
                            label="Assignment Number"
                            inputValue={assignmentNumber}
                            setInputValue={setAssignmentNumber}
                            setErrorMsg={setErrAssignmentNumber}
                        />
                    </div>
                </div>

                <div className="row mt-2">

                    <div className='col-md-6'>
                        <FromFieldDate
                            disabled={true}
                            label="Assignment Accepted Date" star="*" placeholder="YYYY-MM-DD"
                            inputValue={acceptedDate}
                            setInputValue={setAcceptedDate}
                        />
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-md-6">
                                <label> Repair Category </label>
                                <span className="star error">  </span>
                            </div>
                            <div className="col-md-6">
                                <select disabled onChange={handleFormCategory} name="alternative_verification"
                                        className="form-select form-select-sm">
                                    <option value="">Select Form repair Category</option>
                                    <option value="AMC"
                                            selected={repairCategory === "AMC" ? "selected" : ''}>AMC
                                    </option>
                                    <option value="warranty"
                                            selected={repairCategory === "Warranty" ? "selected" : ''}>warranty
                                    </option>
                                    <option value="Insurance"
                                            selected={repairCategory === "Insurance" ? "selected" : ''}>Insurance
                                    </option>
                                    <option value="Paid service"
                                            selected={repairCategory === "Paid service" ? "selected" : ''}>Paid
                                        service
                                    </option>
                                    <option value="Others"
                                            selected={repairCategory === "Others" ? "selected" : ''}>Others
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">

                    <div className='col-md-6'>
                        <FromFieldText
                            readOnly={true}
                            star="*"
                            label="Assigned To"
                            placeholder="Assigned To User Name"
                            inputValue={assignedTo}
                            setInputValue={setAssignedTo}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <h6 className="text-center">List of Equipment</h6>
                    <table className="table table-bordered equipment-table">
                        <thead className="text-center">
                        <tr>
                            <th>Sl #</th>
                            <th>TAG No</th>
                            <th>TAG Name</th>
                            <th>Item Description</th>
                        </tr>
                        </thead>
                        <tbody className="text-center">
                        {aInfo && aInfo.length > 0 ? (
                            aInfo.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.tag_name}</td>
                                    <td>{item.tag_name}</td>
                                    <td>{item.equipment_desc}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4">No equipment data available</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Brief description of the problem reported <span className="error">*</span></label>
                    </div>
                    <div className='col-md-6'>
                        <FromSpFieldTextAreaHari maxLength="2000" numRows="5"
                                                 readOnly={true}
                                                 inputValue={detailProblem}
                                                 setInputValue={setDetailProblem}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Brief description of the actual problem identified<span
                            className="error">*</span></label>
                    </div>
                    <div className='col-md-6'>
                        <FromSpFieldTextAreaHari maxLength="2000" numRows="5" readOnly
                                                 inputValue={detailProblemIdentified}
                                                 setInputValue={setDetailProblemIdentified}
                        />
                    </div>
                </div>

                <div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label>Upload Files of the Problem (if applicable)</label>
                            <br/>
                            <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                                Maximum
                                size: 5 MB. Maximum 5 files allowed at
                                once. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                            <input type="file" name="uploadFile" multiple/>
                        </div>
                    </div>
                    <div>
                        <div className="col-md-12 mt-3">
                            <label>Upload Screenshots of the Problem (if
                                applicable) &nbsp;&nbsp;&nbsp;&nbsp;</label>
                            <br/>
                            <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                                Maximum
                                size: 5 MB. Maximum 5 files allowed
                                once.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                            <input type="file" name='uploadScreenshot' multiple
                            />
                        </div>

                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label> Any Materials Used <span className="error">*</span></label>
                        <span className="star error">  </span>
                    </div>
                    <div className="col-md-3">
                        <select disabled onChange={handleMaterial} name="materialUsed"
                                className="form-select form-select-sm" value={materialUsed}>
                            <option value="">Select Material Used or not</option>
                            <option value="Yes"
                                    selected={materialUsed === "Yes" ? "selected" : ''}>Yes
                            </option>
                            <option value="No"
                                    selected={materialUsed === "No" ? "selected" : ''}>No
                            </option>
                        </select>
                    </div>
                </div>

                {/* Conditionally render the table if materialUsed is "Yes" */}
                {materialUsed === "Yes" && (
                    <div className="row mt-3" style={{maxHeight: '350px', overflowY: 'auto'}}>
                        <h6 className="text-center">List of Material Used</h6>
                        <table className="table table-bordered">
                            <thead className="text-center">
                            <tr>
                                <th>Sl #</th>
                                <th>Date</th>
                                <th>Material Name</th>
                                <th>Part Number</th>
                                <th>Make</th>
                                <th>Model</th>
                                <th>Serial No</th>
                                <th>Qty</th>
                                <th>Cost</th>
                            </tr>
                            </thead>
                            <tbody className="text-center">
                            {materials.map((material, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td><input readOnly type="date" name="date" value={material.date}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="text" name="name" value={material.name}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="text" name="partNumber" value={material.partNumber}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="text" name="make" value={material.make}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="text" name="model" value={material.model}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input type="text" name="serialNo" value={material.serialNo}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="number" name="qty" value={material.qty}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                    <td><input readOnly type="number" name="cost" value={material.cost}
                                               onChange={(e) => handleInputChange(index, e)}/></td>
                                </tr>
                            ))}
                            {/* Calculate and display totals */}
                            <tr>
                                <td colSpan="7" className="text-right"><strong>Total</strong></td>
                                <td>
                                    <strong>{materials.reduce((acc, material) => acc + Number(material.qty || 0), 0)}</strong>
                                </td>
                                <td>
                                    <strong>{materials.reduce((acc, material) => acc + Number(material.cost || 0), 0).toFixed(2)}</strong>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                )}


                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Date of Completion<span className="error">*</span></label>
                    </div>
                    <div className='col-md-6'>
                        <FromFieldDateHari
                            readOnly={true}
                            label="Assignment Accepted Date" star="*" placeholder="YYYY-MM-DD"
                            inputValue={dateOfCopletion}
                            setInputValue={setDateOfCopletion}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Time of Completions<span className="error">*</span></label>
                    </div>
                    <div className='col-md-6'>
                        <FromFieldTime
                            readOnly
                            label="Assignment Accepted Date" star="*" placeholder="HH:mm"
                            inputValue={timeOfCompletion}
                            setInputValue={setTimeOfCompletion}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Next Service Due (if Any)<span
                            className="error">*</span></label>
                        <span className="star error"></span>
                    </div>
                    <div className="col-md-3">
                        <select disabled onChange={handleServices} name="nextServiceDue"
                                className="form-select form-select-sm">
                            <option value="">Select Service Due</option>
                            <option value="Yes" selected={nextServiceDue === "Yes"}>Yes</option>
                            <option value="No" selected={nextServiceDue === "No"}>No</option>
                        </select>
                    </div>
                </div>

                {showTextField && (
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>If Yes, select the date<span className="error">*</span></label>
                        </div>
                        <div className="col-md-6">
                            <FromFieldDateHari
                                maxLength={2000}
                                numRows={5}
                                readOnly
                                className="form-control"
                                inputValue={nextServiceDate}
                                setInputValue={setNextServiceDate}
                                onChange={(e) => setNextServiceDate(e.target.value)}
                            />
                        </div>
                    </div>
                )}

                <div className="row mt-3">
                    <div className="col-md-6">
                        <label> Closing Note <span
                            className="error">*</span></label>
                        <span className="star error">  </span>
                    </div>
                    <div className="col-md-3">
                        <select disabled onChange={handleClosingNote} name="alternative_verification"
                                className="form-select form-select-sm">
                            <option value="">Select Closing Note</option>
                            <option value="4"
                                    selected={closingNote === "4" ? "selected" : ''}>Repair Completed - Asset Working
                            </option>
                            <option value="5"
                                    selected={closingNote === "5" ? "selected" : ''}>Recommended for Disposal
                            </option>
                            <option value="6"
                                    selected={closingNote === "6" ? "selected" : ''}>Repair Not Completed - Send to
                                external
                            </option>
                        </select>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12">

                    </div>

                </div>

                <div className="row">
                    <div className="col-12 text-center">
                        <button onClick={handleBackClick} className="btn btn-secondary btn-sm ms-3">
                            Back
                        </button>
                        <a href={`/ir-assessment-report?assignment_no=${encodeURIComponent(encryptedAssignmentNO)}`}>
                            <button type="button" className="btn btn-danger btn-sm ms-3">
                                Edit Report
                            </button>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default IRAssessmentViewReport;